// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ad-button {
    background-color: #ffffff;
    color: #000000;
    padding: 10px 10px;
    margin: 0 30px;
    display: flex;
    align-items: center;
    border: 1px solid #ffffff;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
    width: 250px;
    box-shadow: 0px 4px 6px rgba(71, 38, 103, 0.3);
}

.ad-button-selected {
    background-color: #e0e0e0;
    border: 1px solid #e0e0e0;
}

.ad-button img {
    width: 50px;
    height: 50px;
    margin-right: 10px;
}

.ad-button span {
    font-size: 18px;
    font-weight: 450;
    padding-left: 5px;
}

.ad-button-column {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    height: 20vh;
    padding-top: 40px;
}

.ad-button-group {
    padding: 0 5%;
}`, "",{"version":3,"sources":["webpack://./src/assets/AdButtonGroup.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".ad-button {\n    background-color: #ffffff;\n    color: #000000;\n    padding: 10px 10px;\n    margin: 0 30px;\n    display: flex;\n    align-items: center;\n    border: 1px solid #ffffff;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    width: 250px;\n    box-shadow: 0px 4px 6px rgba(71, 38, 103, 0.3);\n}\n\n.ad-button-selected {\n    background-color: #e0e0e0;\n    border: 1px solid #e0e0e0;\n}\n\n.ad-button img {\n    width: 50px;\n    height: 50px;\n    margin-right: 10px;\n}\n\n.ad-button span {\n    font-size: 18px;\n    font-weight: 450;\n    padding-left: 5px;\n}\n\n.ad-button-column {\n    display: flex;\n    justify-content: space-around;\n    align-items: flex-start;\n    height: 20vh;\n    padding-top: 40px;\n}\n\n.ad-button-group {\n    padding: 0 5%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
